<template>
  <div>
    <!--<h2>Сделки</h2>-->
    <b-row>
      <b-col cols="4">
        <b-form-group class="mb-0">
          <b-form-select v-model="currentFunnel" :options="$store.getters.funnelOptions" @change="onChangeCurrentFunnel"/>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- buttons -->
    <b-row class="my-3">
      <b-col class="d-flex justify-content-between">
        <b-button
          v-b-modal.modal-1
          @click="onCreateButton"
          size="sm"
        >
          Добавить
        </b-button>

        <b-button
          variant="outline-primary"
          size="sm"
          style="border: none;"
          @click="isShowFilters = !isShowFilters"
        >
          <b-icon icon="filter"/>
          <span>{{ isShowFilters ? 'Скрыть фильтр' : 'Показать фильтр' }}</span>
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <!-- search form -->
        <search-form
          :error-result="errorResult"
          :message-result="messageResult"
          :search-query="searchQuery"
          :submit-search="submitSearch"
          :statuses="currentStatuses"
          name-label="Быстрый поиск"
          :reset-search="resetSearch"
          :is-show-filters="isShowFilters"
        />
      </b-col>
      <b-col cols="12">
        <b-alert show variant="warning">
          <span>Всего сделок: {{ totals.all || 0 }} шт. </span>
          <span v-if="amounts.all">(на сумму {{ amounts.all || 0 }} руб.)</span>
        </b-alert>
      </b-col>
    </b-row>

    <!-- change status modal -->
    <b-modal id="modal-set-status" size="sm" title="Изменение статуса" hide-footer>
      <b-button
        v-for="status in currentStatuses"
        :key="status.name"
        block
        @click="changeStatusSelected(status.name)"
      >{{ status.title }}</b-button>
    </b-modal>

    <!-- set tags modal -->
    <b-modal id="modal-set-tags" size="sm" title="Изменение тэгов" hide-footer>
      <b-form-group>
        <tags v-bind:value="selectedTags" v-on:input="selectedTags = $event"></tags>
      </b-form-group>

      <b-form-group>
        <b-button block @click="changeTagsSelected">Установить тэги</b-button>
      </b-form-group>
    </b-modal>

    <!-- modal -->
    <b-modal id="modal-1" size="lg" title="Новая сделка" hide-footer>
      <b-form @submit="createDeal" size="sm">
        <b-form-group label="Воронка:" label-cols-sm="4" label-cols-lg="4">
          <b-form-select v-model="form.funnel" :options="$store.getters.funnelOptions"></b-form-select>
        </b-form-group>
        <b-form-group label="Название:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
            type="text" required
            v-model="form.title"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Сумма:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
            type="number" required
            step="0.01"
            v-model="form.amount"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Статус:" label-cols-sm="4" label-cols-lg="4">
          <b-form-select v-model="form.status" :options="statusOptions"></b-form-select>
        </b-form-group>

        <b-form-group label="Компания:" label-cols-sm="4" label-cols-lg="4">
          <multi-select
            v-model="form.company"
            :options="optionsCompanies"
            :searchable="true"
            :loading="isLoading"
            :internal-search="false"
            :hide-selected="true"
            track-by="title"
            label="title"
            placeholder="Введите название для поиска"
            selectLabel="Enter чтобы выбрать"
            @search-change="asyncFind"
          >
            <template slot="noOptions">Начните вводить название</template>
            <template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
            <template slot="option" slot-scope="props">
              {{ props.option.title }}
            </template>
            <span slot="noResult">Не найдено</span>
          </multi-select>
        </b-form-group>

        <b-alert v-model="error" dismissible variant="danger">{{ message }}</b-alert>
        <loading-button :is-busy="isBusy" text="Создать"></loading-button>
      </b-form>
    </b-modal>



    <!-- buttons -->
    <b-row class="my-3">
      <b-col class="d-flex justify-content-between">
        <b-button-group v-if="selectedDeals.length > 0">
          <b-button
            @click="checkDealAll"
            size="sm"
          >
            Выделить все
          </b-button>
          <b-button
            @click="uncheckDealAll"
            size="sm"
          >
            Снять все
          </b-button>
          <b-button
            v-b-modal.modal-set-status
            size="sm"
          >
            Изменить статус
          </b-button>
          <b-button
            v-b-modal.modal-set-tags
            size="sm"
          >
            Изменить тэги
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <div class="board" v-drag-and-drop:options="options">
      <board-column v-for="status in currentStatuses"
                    v-bind:key="status.name"
                    :status="status.name"
                    :deals="filterDealsByStatus(status.name)"
                    :selectedDeals="selectedDeals"
                    :title="status.title"
                    :total="totals[status.name]"
                    :amount="amounts[status.name]"
                    v-on:draggedInto="setStatus(status.name, $event)"
                    v-on:nextPage="page++"
                    v-on:checkDeal="checkDeal"
                    v-on:checkDealColumn="checkDealColumn"
      ></board-column>
    </div>
  </div>
</template>

<script>
import Tags from "../components/tags";
import BoardColumn from "../components/BoardColumn";
import {VueDraggableDirective} from 'vue-draggable';
import LoadingButton from "../components/LoadingButton";
import MultiSelect from 'vue-multiselect'
import SearchForm from "../components/SearchForm";

export default {
  name: "Deals",
  components: {Tags, BoardColumn, LoadingButton, MultiSelect, SearchForm},
  directives: {
    dragAndDrop: VueDraggableDirective
  },
  props: {
    tabKey: Number,
    filterData: Object,
  },
  data() {
    return {
      currentFunnel: "camp",
      isLoading: false,
      optionsCompanies: [],
      options: {
        dropzoneSelector: 'div.column',
        draggableSelector: '.draggable-card',
        showDropzoneAreas: false,
        multipleDropzonesItemsDraggingEnabled: true,
      },
      isBusy: false,
      loading: false,
      errorResult: null,
      messageResult: '',

      error: false,
      message: '',

      form: {
        title: '',
        amount: 0,
        status: 'new',
        funnel: "camp",
      },
      deals: [],
      totals: {},
      amounts: {},
      isShowFilters: true,
      page: 1,
      searchQuery: {
        query: '',
        tags: [],
        status: null,
        created_from: null,
        created_to: null
      },
      selectedDeals: [],
      selectedTags: [],
    }
  },
  computed: {
    currentStatuses() {
      let funnels = [];
      funnels = this.$store.getters.funnels.filter(funnel => funnel.name === this.currentFunnel)
      if (funnels.length === 0) return [];
      return funnels[0].statuses;
    },
    statusOptions() {
      let funnels = [];
      funnels = this.$store.getters.funnels.filter(funnel => funnel.name === this.form.funnel)
      if (funnels.length === 0) return [];
      let opts = [];
      funnels[0].statuses.forEach(e => {
        opts.push({value: e.name, text: e.title});
      });
      return opts;
    },
  },
  created() {
  //
  },
  mounted() {
    if (localStorage.getItem('current-funnel')) {
      this.currentFunnel = localStorage.getItem('current-funnel');
    }
    if (this.filterData) {
      try {
        //this.searchQuery = JSON.parse(localStorage.getItem('searchFilter'));
        this.searchQuery = this.filterData;
      } catch (e) {
        console.error(e)
        this.searchQuery.query = null
        this.searchQuery.tags = []
        this.searchQuery.status = null
        this.searchQuery.created_from = null
        this.searchQuery.created_to = null
        this.searchQuery.paymentAtFrom = null
        this.searchQuery.paymentAtTo = null
      }
    }
  },
  watch: {
    "currentFunnel": {
      handler: function (data) {
        if (data) {
          this.deals = [];

          if (this.page === 1)
            this.fetchDeals();
          else
            this.page = 1;
        }
      },
      immediate: false,
      deep: false
    },
    "page": {
      handler: function (data) {
        if (data) {
          this.fetchDeals();
        }
      },
      immediate: false,
      deep: false
    },
    //"searchQuery": {
    //  handler: function (data) {
    //    if (data) {
    //      this.updateTabFilter(data)
    //      //localStorage.setItem('searchFilter', JSON.stringify(data))
    //    }
    //  },
    //  immediate: false,
    //  deep: true
    //},
  },
  methods: {
    checkDeal(value) {
      const index = this.selectedDeals.indexOf(value.id);
      if (value.checked) {
        if (index === -1) {
          this.selectedDeals.push(value.id);
        }
      } else {
        if (index !== -1) {
          this.selectedDeals.splice(index, 1);
        }
      }
      //console.log(this.selectedDeals);
    },
    checkDealAll() {
      this.selectedDeals = this.deals.map(x => x.id);
    },
    uncheckDealAll() {
      this.selectedDeals = [];
    },
    checkDealColumn(value) {
      this.deals.forEach((deal) => {
        if (deal.status === value.status) {
          this.checkDeal({ id: deal.id, checked: value.checked })
        }
      });
    },
    changeStatusSelected(status) {
      this.isLoading = true
      this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/deals/set-statuses', JSON.stringify({
        dealIds: this.selectedDeals,
        status: status
      }))
        .then(() => {
          this.$bvModal.hide('modal-set-status');
          this.selectedDeals = [];
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.fetchDeals();
          this.loading = false;
        });
    },
    changeTagsSelected() {
      this.isLoading = true
      this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/deals/set-tags', JSON.stringify({
        dealIds: this.selectedDeals,
        tags: this.selectedTags
      }))
        .then(() => {
          this.$bvModal.hide('modal-set-tags');
          this.selectedDeals = [];
          this.selectedTags = [];
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.fetchDeals();
          this.loading = false;
        });
    },
    filterUpdate() {
      this.$emit('filterUpdate', this.tabKey, this.searchQuery);
    },
    filterDealsByStatus(status) {
      return this.deals.filter(deal => deal.status === status);
    },
    submitSearch(evt) {
      evt.preventDefault();
      this.filterUpdate();
      this.fetchDeals();
    },
    resetSearch(evt) {
      evt.preventDefault();
      this.searchQuery.query = null
      this.searchQuery.status = null
      this.searchQuery.tags = []
      this.searchQuery.created_from = null
      this.searchQuery.created_to = null
      this.searchQuery.paymentAtFrom = null
      this.searchQuery.paymentAtTo = null

      this.filterUpdate();
      this.fetchDeals();
    },
    asyncFind(query) {
      this.isLoading = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/companies?query=' + query);
      return promise.then(response => {
        this.optionsCompanies = response.data.companies;
        this.isLoading = false;
      })
        .catch((error) => {
          console.error(error);
          this.optionsCompanies = [];
          this.isLoading = false;
        });
    },
    onCreateButton() {
      this.form.title = '';
      this.form.amount = 0;
      this.form.status = 'new';
      this.form.funnel = this.currentFunnel
    },
    createDeal(evt) {
      evt.preventDefault();
      this.error = false;
      this.isBusy = true;
      this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/deals/', JSON.stringify(this.form)
      ).then((response) => {
        this.isBusy = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.$bvModal.hide('modal-1');
            this.deals.push(response.data.deal);
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      }).catch((error) => {
        console.error(error);
        this.error = true;
        this.message = "Непредвиденная ошибка";
      });
    },
    fetchDeals() {
      if (!this.loading)
        this.loading = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/deals/' +
        "?page=" + this.page +
        "&query=" + (this.searchQuery.query ? this.searchQuery.query : '') +
        "&created_from=" + this.searchQuery.created_from +
        "&created_to=" + this.searchQuery.created_to +
        "&paymentAtFrom=" + this.searchQuery.paymentAtFrom +
        "&paymentAtTo=" + this.searchQuery.paymentAtTo +
        "&funnel=" + this.currentFunnel +
        "&tags=" + JSON.stringify(this.searchQuery.tags) +
        "&status=" + this.searchQuery.status)
        .then(response => {
          this.selectedDeals = [];
          if (this.page === 1) {
            this.deals = response.data.deals;
          } else {
            this.deals = this.deals.concat(response.data.deals);
          }
          this.totals = response.data.total;
          this.amounts = response.data.totalAmount;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          if (this.page === 1) {
            this.deals = [];
          }
          this.loading = false;
        });
    },
    setStatus(status, ids) {
      this.deals = this.deals.map(obj =>
        obj.id === (ids[0] * 1) ? {...obj, status: status} : obj
      );
      this.axios.patch(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + ids[0], {status: status})
        .then(response => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onChangeCurrentFunnel(val) {
      localStorage.setItem('current-funnel', val);
    },
  }
}
</script>

<style scoped lang="scss">
.board {
  display: flex;
  flex-flow: row nowrap;
  max-width: calc(100vw - 200px);
  //overflow-x: scroll;
  //overflow-x: auto;
}
</style>
